export function startRingtone() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return () => {};
  const ctx = new Ctx();
  try { ctx.resume(); } catch {}
  // Fallback: flash the tab title in case audio is suspended (autoplay policy)
  const originalTitle = document.title;
  const titleInterval = setInterval(() => {
    document.title = document.title.startsWith("🔔") ? originalTitle : `🔔 Incoming call — ${originalTitle}`;
  }, 800);
  const carrier = ctx.createOscillator();
  carrier.type = "sine";
  carrier.frequency.value = 440;
  const mod = ctx.createOscillator();
  mod.type = "sine";
  mod.frequency.value = 40;
  const modGain = ctx.createGain();
  modGain.gain.value = 480;
  const carrierGain = ctx.createGain();
  carrierGain.gain.value = 0;
  mod.connect(modGain);
  modGain.connect(carrier.frequency);
  carrier.connect(carrierGain);
  carrierGain.connect(ctx.destination);
  carrier.start();
  mod.start();
  const ringOn = () => {
    carrierGain.gain.setValueAtTime(0.12, ctx.currentTime);
    carrierGain.gain.setValueAtTime(0.12, ctx.currentTime + 1.8);
    carrierGain.gain.setValueAtTime(0, ctx.currentTime + 2);
  };
  ringOn();
  const interval = setInterval(ringOn, 3000);
  return () => {
    clearInterval(interval);
    clearInterval(titleInterval);
    document.title = originalTitle;
    try { carrier.stop(); mod.stop(); } catch {}
    try { ctx.close(); } catch {}
  };
}
